export default [
    {
        name: 'Despesas',
        url: '/despesasgerais/gerentes/despesas',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'DESP-GERAIS-GER-00'
    },
    {
        name: 'Pagamentos',
        url: '/despesasgerais/gerentes/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'GERENTE'
        },
        regras: 'DESP-GERAIS-GER-PAG-00'
    },
]